import './tagInfo.scss'
import templateUrl from './tagInfo.html'
import icon from './tagInfo.svg'

/**
 * Tag Info Operation route.
 *
 * @namespace routes.OperationTagInfo
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.tagInfo',
  label: 'OPERATIONS.TAGINFO.TITLE',
  url: '/tag-info',
  resolve: {
    antenna: /*@ngInject*/ ActiveWorkstation => ActiveWorkstation.getAntennas(),
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
  },
  component: 'tmrOperationTagInfo',
  accessControl: ['Operation.perform', 'Operation.TagInfo.perform'],
  weight: 6,
  icon,
}

/**
 * Tag Info Operation component.
 *
 * @type {ngComponent}
 */
export const tmrOperationTagInfo = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationController',
  bindings: {
    antenna: '<',
    productImageEnabled: '<',
  },
}
